
  import { mapState } from 'vuex'
  export default {
    name: 'CustomCase',
    props: {
      dataList: {
        type: Array,
        default: null,
      },
    },
    data() {
      return {
        left: require('~/assets/image/scence/arrow-left.png'),
        directionObj: {
          left: false,
          right: false,
        },
        datalist: [
          {
            src: require('~/assets/image/scence/customer-case/customer01.png'),
            title: '第一届“轨道好青年”评选',
            desc: '宣传工作每天都离不开问卷网。从活动报名到活动宣传，再到数据统计，很难想象如果用线下的方式做需要耗费多大的人力物力。',
            author: '史先生',
            comment: '宣传文化管理员 苏州轨道交通',
          },
          {
            src: require('~/assets/image/scence/customer-case/customer02.png'),
            title: '大学生就业择 业态度小调查',
            desc: '做品牌做运营都离不开用户调查，问卷网帮助我们非常方便的展开目标人群的快速调研，对我们做品宣活动提供了非常有用的洞察。',
            author: 'Mocca ',
            comment: '品牌运营 ',
          },
          {
            src: require('~/assets/image/scence/customer-case/customer03.png'),
            title: '首届千聊摄影大赛',
            desc: '千聊的用户都是非常爱学习的用户，所以我们需要经常为千聊用户提供舞台，展示他们的学习成果与才艺，问卷网是真的提供了有力的工具。',
            author: '任老师',
            comment: '宣传负责人  北师大学心理学部',
          },
          {
            src: require('~/assets/image/scence/customer-case/customer04.png'),
            title: '2022年首都高校心理健康知识竞赛',
            desc: '问卷网是学生与老师的好帮手，它功能齐全，页面美观、使用便捷，值得拥有哦～',
            author: '任老师',
            comment: '宣传负责人  北师大学心理学部',
          },
          {
            src: require('~/assets/image/scence/customer-case/customer06.png'),
            title: '第六届鲁泉杯钱币知识答题活动',
            desc: '问卷网真的太方便了，它支持多人同时在线答题，再也不用担心活动太大工具支撑不了的情况，做知识竞赛就用问卷网。',
            author: '李先生 ',
            comment: '行政助理  山东省钱币学会',
          },
        ],
        testdata: [],
      }
    },
    computed: {
      ...mapState(['isMobile']),
    },
    methods: {
      click(direction) {
        const commonCarouselStep = this.$refs.CommonCarouselStep
        if (commonCarouselStep) {
          commonCarouselStep.moving(direction)
        }
      },
      boundary({ type, value }) {
        this.directionObj[type] = value
      },
    },
  }
